export default __webpack_public_path__ + "static/sprited-icons-fc3298a3c5467ea310f4acaa29e2f01e.svg";